import { useState } from "react";
import { sendContact } from "../lib/api";
import { Mail, Instagram, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "General", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await sendContact(form); setSent(true); toast.success("Message sent — we'll reply within 24 hours."); }
    catch { toast.error("Something went wrong"); }
  };
  return (
    <div data-testid="contact-page" className="container-luxe py-16 grid grid-cols-1 lg:grid-cols-2 gap-16">
      <div>
        <p className="overline text-gold mb-3">Contact</p>
        <h1 className="h-display text-5xl sm:text-6xl mb-6">Let's Talk.</h1>
        <p className="text-sm text-muted-foreground font-light leading-relaxed max-w-md mb-10">
          Questions about sizing, orders, or partnerships? Our care team is here for you and replies within 24 hours.
        </p>
        <div className="space-y-5">
          <a href="mailto:care@svathletic.com" className="flex items-center gap-3 text-sm hover:text-gold transition-colors"><Mail size={18} strokeWidth={1.4} /> care@svathletic.com</a>
          <a href="#" className="flex items-center gap-3 text-sm hover:text-gold transition-colors"><Instagram size={18} strokeWidth={1.4} /> @svathleticwear</a>
          <a href="#" className="flex items-center gap-3 text-sm hover:text-gold transition-colors"><MessageCircle size={18} strokeWidth={1.4} /> Live chat, 9am–6pm EST</a>
        </div>
      </div>

      <div>
        {sent ? (
          <div className="border border-hairline p-12 text-center" data-testid="contact-success">
            <h3 className="font-serif text-3xl mb-3">Thank You ✦</h3>
            <p className="text-sm text-muted-foreground font-light">We've received your message and will be in touch shortly.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5 border border-hairline p-8 sm:p-10" data-testid="contact-form">
            <input required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" className="w-full border-b border-hairline py-3 bg-transparent outline-none text-sm" />
            <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" className="w-full border-b border-hairline py-3 bg-transparent outline-none text-sm" />
            <select value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" className="w-full border-b border-hairline py-3 bg-transparent outline-none text-sm">
              {["General", "Order Support", "Returns & Exchanges", "Partnerships", "Press"].map((s) => <option key={s}>{s}</option>)}
            </select>
            <textarea required rows={5} placeholder="Your message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" className="w-full border border-hairline p-4 bg-transparent outline-none text-sm" />
            <button type="submit" className="btn-primary w-full" data-testid="contact-submit">Send Message</button>
          </form>
        )}
      </div>
    </div>
  );
}
